import axios from 'axios';

export const http = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
})

export const isExpired = (ret) => {
    return (ret.Codigo == 500 && ret.CodigoInterno == 4)
}

export const HTTP_TOKEN = localStorage.getItem('ampm_token');
export const REJECT_MSG = 'Sessao expirou';